import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { AutoreDTO } from "../dto/autoreDTO";
import { AutoreVO } from "../vo/autoreVO";
import { MapperUtente } from "./mapper-utente";
import { MapperSettore } from "./mapper-settore";
import { MapperStruttura } from "./mapper-struttura";
import { MapperStrutturaFascicolo } from "./mapper-struttura-fascicolo";
import { UtenteDTO } from "../dto/utenteDTO";
import { UtenteVO } from "../vo/utenteVO";

@Injectable({
  providedIn: "root",
})
export class MapperAutore implements MapperInterface<AutoreDTO, AutoreVO> {
  constructor(
    private mapperUtente: MapperUtente,
    private mapperStruttura: MapperStrutturaFascicolo
  ) {}

  convertVoToDto(e: AutoreVO): AutoreDTO {
    const autoreDTO = new AutoreDTO();
    if (e !== null && e !== undefined) {
      autoreDTO.utente = new UtenteDTO();
      autoreDTO.utente = this.mapperUtente.convertVoToDto(e.utente);
      autoreDTO.struttura = this.mapperStruttura.convertVoToDto(e.struttura);
    }
    return autoreDTO || new AutoreDTO();
  }
  convertDtoToVo(t: AutoreDTO): AutoreVO {
    const autoreVO = new AutoreVO();
    if (t !== null && t !== undefined) {
      autoreVO.utente = new UtenteVO();
      autoreVO.utente = this.mapperUtente.convertDtoToVo(t.utente);
      autoreVO.struttura = this.mapperStruttura.convertDtoToVo(t.struttura);
    }
    return autoreVO || new AutoreVO();
  }
  convertListVoToDto(e: AutoreVO[]): AutoreDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: AutoreDTO[]): AutoreVO[] {
    if (t != null) {
      return t.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
